import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../../../core/services/master-data.service';
import { Observable } from 'rxjs';
import { IState, IMasterData, IRequestAQuoteBody, MasterData, IRequestAQuoteLbl } from '../../../../core/models';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { QuoteService } from '../../../../core/services/quote.service';
import { Router } from '@angular/router';
import { FileInfo, FileRestrictions, SuccessEvent } from '@progress/kendo-angular-upload';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';

@Component({
  selector: 'app-request-quote',
  templateUrl: './request-quote.component.html',
  styleUrls: ['./request-quote.component.scss']
})
export class RequestQuoteComponent implements OnInit {
  getQuoteType: MasterData[];
  getMarketSegment: MasterData[];
  getjobState: MasterData[];
  showCancelConfirmation: boolean;
  public confirmWindowOpened = false;
  public saveInProcess: boolean;
  jobName: any;
  openedNoFileConfirmationBox: boolean;
  processWithoutFiles: boolean;
  requestQuoteTxt: IRequestAQuoteLbl;
  constructor(private quoteService: QuoteService, private formBuilder: FormBuilder, private router: Router, private languageTranslationService: LanguageTranslationService) { }
  requestQuote: FormGroup;
  uploadedfileNames: string[] = [];
  uploadedPathForQuoteFile: string[] = [];
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png", ".jfif", ".pdf", ".doc", ".docx", ".csv", ".xls", ".xlsx"],
  };
  myFiles: Array<FileInfo> = [];
  ngOnInit() {
    this.loadLanguageTranslationData();
    this.bidMinimumDate();
    this.minimumDate();
    this.requestQuote = this.formBuilder.group({
      jobName: new FormControl(),
      jobCity: new FormControl(),
      jobState: new FormControl(),
      marketSegment: new FormControl(),
      quoteType: new FormControl(),
      quoteRequestDate: new FormControl(),
      bidDate: new FormControl(),
      leed: new FormControl(false),
      blast: new FormControl(false),
      customerSupplied: new FormControl(false),
      purchaseHardware: new FormControl(false),
      //attachedFile  
      projectDetails: new FormControl(),
    })
    this.bindDropdownData();//calling dropdown binding method here

  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "jobNameLbl" },
      { controlName: "jobCityLbl" },
      { controlName: "jobStateLbl" },
      { controlName: "marketSegmentLbl" },
      { controlName: "quoteTypeLbl" },
      { controlName: "quoteRequestDate" },
      { controlName: "bidDateLbl" },
      { controlName: "leedLbl" },
      { controlName: "indicateTypeLbl" },
      { controlName: "blastLbl" },
      { controlName: "customerSuppliedHardwareLbl" },
      { controlName: "purchaseHardware" },
      { controlName: "attachmentLbl" },
      { controlName: "projectDetails" },
      { controlName: "cancelButtonLbl" },
      { controlName: "requestQuoteButtonLbl" },
      { controlName: "noLbl" },
      { controlName: "yesLbl" },
      { controlName: "cancelConfirmLbl" },
      { controlName: "quoteSubmittedLbl" },
      { controlName: "thanksLbl" },
      { controlName: "quoteGridLbl" },
      { controlName: "submittedJobLbl" },
      { controlName: "returnToInHouseQuoteLbl" },
      { controlName: "addNewQuoteRequestLbl" },
      { controlName: "requestSubmittedToKawneerLbl" },
      { controlName: "confirmTitleLbl" },
      { controlName: "noFilesUploadedLbl" },
      { controlName: "invalidProjectDetailsLbl" },
    ];
    const componentName = "requestAQuote";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.requestQuoteTxt = response[response.length - 1];
      console.log(response);
    }
  }
  //#endregion  
  //#region quote request form labels
  public requestQuotes = {
    jobNameLbl: 'Job Name',
    jobCityLbl: 'Job City',
    jobStateLbl: 'Job State',
    marketSegmentLbl: 'Market Segment',
    quoteTypeLbl: 'Quote Type',
    quoteRequestDate: 'Request Date',
    bidDateLbl: 'Bid Date',
    leedLbl: 'Leed',
    indicateTypeLbl: 'Please indicate the quote type',
    blastLbl: 'Blast',
    customerSuppliedHardwareLbl: 'Customer Supplied Hardware',
    purchaseHardware: 'Kawneer Purchased Hardware',
    attachmentLbl: 'Attachment',
    projectDetails: 'Project Details',
    cancelButtonLbl: 'Cancel',
    requestQuoteButtonLbl: 'Request a Quote',
    invalidProjectDetailsLbl: 'Project Details must be at least 12 characters',
    noLbl: "No",
    yesLbl: "Yes",
    cancelConfirmLbl: "Are you sure you want to cancel?",
    quoteSubmittedLbl: "New Quote Request Submitted",
    thanksLbl: "Thank you for choosing Kawneer!",
    quoteGridLbl: '"Quote" grid under "Manage Quotes"',
    submittedJobLbl: 'Submitted job',
    returnToInHouseQuoteLbl: "Return To In-House Quotes",
    addNewQuoteRequestLbl: "Add New Quote Request",
    requestSubmittedToKawneerLbl: 'Your quote request has been submitted to Kawneer!  Track the status of your quotes via the "In-House',
    confirmTitleLbl: 'Please Confirm',
    noFilesUploadedLbl: 'No files have been uploaded! Click Yes to continue submission, or No to return and add files.',
    //add more labels here
  }
  //#endregion
  //#region  request quote form dropdown data binding method
  bindDropdownData() {
    this.quoteService.requestAQuotePayload().subscribe((response) => {
      if (response) {
        console.log(response)
        this.getMarketSegment = response.marketSegments;
        this.getQuoteType = response.quoteTypes;
        this.getjobState = response.states
      } else {
        //do something
      }
    })
  }
  //#endregion
  //#region validation implementation
  isSubmitted: boolean;
  public requestQuoteControls = {
    isSubmitted: false,
    isInvalidJobName: false,
    isInvalidCity: false,
    isInvalidState: false,
    isInvalidMarketSegment: false,
    isInvalidConfirmEmail: false,
    isInvalidQuoteType: false,
    isInvalidQuoteRequestDate: false,
    isInvalidBidDate: false,
    isInvalidProjectDetails: false
  };
  public validateRequestQuoteForm(): boolean {
    let isValid = true;
    if (!this.requestQuoteControls) {
      return;
    }
    const controls = this.requestQuote.controls;
    if (this.requestQuoteControls.isSubmitted) {

      if (controls.jobName.value) {
        this.requestQuoteControls.isInvalidJobName = false;
      } else {
        this.requestQuoteControls.isInvalidJobName = true;
        isValid = false;
      }

      if (controls.jobCity.value) {
        this.requestQuoteControls.isInvalidCity = false;
      } else {
        this.requestQuoteControls.isInvalidCity = true;
        isValid = false;
      }

      if (controls.jobState.value) {
        this.requestQuoteControls.isInvalidState = false;
      } else {
        this.requestQuoteControls.isInvalidState = true;
        isValid = false;
      }
      if (controls.marketSegment.value) {
        this.requestQuoteControls.isInvalidMarketSegment = false;
      } else {
        this.requestQuoteControls.isInvalidMarketSegment = true;
        isValid = false;
      }
      if (controls.quoteType.value) {
        this.requestQuoteControls.isInvalidQuoteType = false;
      } else {
        this.requestQuoteControls.isInvalidQuoteType = true;
        isValid = false;
      }
      if (controls.quoteRequestDate.value) {
        this.requestQuoteControls.isInvalidQuoteRequestDate = false;
      } else {
        this.requestQuoteControls.isInvalidQuoteRequestDate = true;
        isValid = false;
      }
      if (controls.bidDate.value) {
        this.requestQuoteControls.isInvalidBidDate = false;
      } else {
        this.requestQuoteControls.isInvalidBidDate = true;
        isValid = false;
      }
      if (controls.projectDetails.value && this.removeTags(controls.projectDetails.value).length > 12) {
        this.requestQuoteControls.isInvalidProjectDetails = false;
      } else {
        this.requestQuoteControls.isInvalidProjectDetails = true;
        isValid = false;
      }
    }
    return isValid;
  }

  //#endregion
  //#region request quote button and cancel button operations
  requestQuoteSubmit() {
    //validate the form here
    this.requestQuoteControls.isSubmitted = true;
    if (!this.validateRequestQuoteForm()) {
      return;
    }
    if (!this.processWithoutFiles && this.uploadedfileNames.length == 0) {
      this.openNoFileConfirmationBox();
      return;
    }
    this.saveInProcess = true;

    const controls = this.requestQuote.controls;
    this.jobName = controls.jobName.value;
    const body = {
      jobName: controls.jobName.value,
      jobCity: controls.jobCity.value,
      jobState: controls.jobState.value ? controls.jobState.value.stateCode : "",
      marketSegment: controls.marketSegment.value ? controls.marketSegment.value.name : "",
      quoteType: controls.quoteType.value ? controls.quoteType.value.name : "",
      quoteTypeId: controls.quoteType.value ? controls.quoteType.value.value : "",
      requestDate: controls.quoteRequestDate.value,//????
      bidDate: controls.bidDate.value,//????
      leed: controls.leed.value ? controls.leed.value : false,
      blast: controls.blast.value ? controls.blast.value : false,
      customerSupplied: controls.customerSupplied.value ? controls.customerSupplied.value : false,
      kawneerPurchasedHardware: controls.purchaseHardware.value ? controls.purchaseHardware.value : false,
      projectDetails: controls.projectDetails.value ? controls.projectDetails.value : "",
      requestFiles: this.uploadedPathForQuoteFile
    }
    this.confirmWindowOpened = false;
    this.quoteService.requestAQuote(body as IRequestAQuoteBody).subscribe((response: IRequestAQuoteBody) => {
      this.saveInProcess = false;
      if (response) {
        //do something
        this.confirmWindowOpened = true;       
      } else {
        //do something
        //this.confirmWindowOpened = true;
      }
      this.requestQuote.reset();
    }, error => { this.saveInProcess = false; })

  }
  confirmWindowClose() {
    this.newQuoteRequest();
  }
  cancel() {
    //show popup confirmation
    this.showCancelConfirmation = true;
  }
  confirmCancel(isYes: boolean) {
    if (isYes) {
      this.router.navigate(["/manage-quote"]);
    } else {
      this.showCancelConfirmation = false;
    }
  }
  //#endregion
  //#region Set minDate to after 3 business day
  public minDate = new Date();
  public bidMinDate = new Date();
  public minimumDate = (): Date => {
    var todaysDate = new Date();
    this.minDate.setDate(todaysDate.getDate() + 3);
    var day = todaysDate.getDay();
    if (day == 6) {
      this.minDate.setDate(this.minDate.getDate() + 1);
    }
    else if (day == 5 || day == 4) {
      this.minDate.setDate(this.minDate.getDate() + 2);
    }
    return new Date(this.minDate.getFullYear(), this.minDate.getMonth() + 1, this.minDate.getDate());
  }

  public bidMinimumDate = (): Date => {
    var todaysDate = new Date();
    this.bidMinDate.setDate(todaysDate.getDate() + 3);
    var day = todaysDate.getDay();
    if (day == 6) {
      this.bidMinDate.setDate(this.bidMinDate.getDate() + 1);
    }
    else if (day == 5 || day == 4) {
      this.bidMinDate.setDate(this.bidMinDate.getDate() + 2);
    }
    return new Date(this.bidMinDate.getFullYear(), this.bidMinDate.getMonth() + 1, this.bidMinDate.getDate());
  }
  public onReqDateChange(value: Date): void {
    this.bidMinDate = value;
  }
  //#endregion
  //for adding new quote after save
  newQuoteRequest() {
    this.confirmWindowOpened = false;
    this.requestQuoteControls.isSubmitted = false;
    this.myFiles = [];
    this.requestQuote.reset();
    this.uploadedPathForQuoteFile = [];
  }

  fileSelected(evt) {
    evt.files.forEach(function (file) {
      if (this.uploadedfileNames.indexOf(file.name) === -1) {
        this.uploadedfileNames.push(file.name);
      }
    }.bind(this));
    this.saveInProcess = true;
  }
  public closeNoFileConfirmationBox(status: boolean) {
    this.processWithoutFiles = status;
    this.openedNoFileConfirmationBox = false;
    if (status) {
      this.requestQuoteSubmit();
    }
  }

  public openNoFileConfirmationBox() {
    this.openedNoFileConfirmationBox = true;
  }

  removeTags(str) {
    if ((str === null) || (str === ''))
      return false;
    else
      str = str.toString();
    return str.replace(/(<([^>]+)>)/ig, '');
  }

  uploadSuccess(evt: SuccessEvent) {
    this.uploadedPathForQuoteFile.push(evt.response.body.paths[0]);
  }
  uploadComplete() {
    this.saveInProcess = false;
  }
}
